import { useEffect, useState } from "react";
import * as api from "../../lib/api.ts";

/** Полный адрес подписанного пути, который отдал сервер. */
export function useAssetUrl(path: string | null): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (path === null) {
      setUrl(null);
      return;
    }
    let alive = true;
    void api.mediaAssetUrl(path).then((full) => {
      if (alive) setUrl(full);
    });
    return () => {
      alive = false;
    };
  }, [path]);
  return url;
}
